import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-top-navigation',
    templateUrl: './top-navigation.component.html',
    styleUrls: ['./top-navigation.component.scss'],
    imports: [CommonModule, MatIconModule]
})
export class TopNavigationComponent implements OnInit {
  environment = environment;
  isMenuOpen = false;
  pageIndex = 0;
  pages: string[] = [];

  @ViewChild('menuButton', { static: false }) menuButton!: ElementRef;

  constructor(private appService: AppService) {
    this.pages = this.appService.pages;
  }

  ngOnInit(): void {
    this.appService.getPageIndex().subscribe({
      next: (pageIndex: number) => {
        this.pageIndex = pageIndex;
      },
      error: (error) => {
        console.error('Error getting pageIndex:', error);
      }
    });
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.top-nav-content');
    if (!clickedInside) {
      this.isMenuOpen = false;
    }
  }

  setPageIndex(pageIndex: number): void {
    this.appService.setPageIndex(pageIndex);
    this.isMenuOpen = false;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      setTimeout(() => {
        const firstMenuItem = document.querySelector('.dropdown-menu [role="menuitem"]');
        (firstMenuItem as HTMLElement)?.focus();
      }, 0);
    } else {
      this.menuButton.nativeElement.focus();
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.menuButton.nativeElement.focus();
  }

  handleMenuKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleMenu();
    }
  }

  handleItemKeydown(event: KeyboardEvent, index: number): void {
    switch (event.key) {
      case 'Enter':
      case ' ':
        this.setPageIndex(index);
        break;
      case 'Escape':
        this.closeMenu();
        break;
      case 'ArrowDown':
        this.focusNextItem(index);
        break;
      case 'ArrowUp':
        this.focusPreviousItem(index);
        break;
    }
  }

  focusNextItem(currentIndex: number): void {
    const nextIndex = (currentIndex + 1) % this.pages.length;
    this.focusItem(nextIndex);
  }

  focusPreviousItem(currentIndex: number): void {
    const prevIndex = (currentIndex - 1 + this.pages.length) % this.pages.length;
    this.focusItem(prevIndex);
  }

  focusItem(index: number): void {
    const menuItems = document.querySelectorAll('.dropdown-menu [role="menuitem"]');
    (menuItems[index] as HTMLElement).focus();
  } 
}
